const CODE_MESSAGE_MAP = {
	areas_required: "Wybierz co najmniej jeden obszar.",
	userid_required: "Wybierz pracownika.",
	unauthorized: "Brak autoryzacji. Zaloguj sie ponownie.",
	forbidden: "Brak uprawnien do wykonania tej operacji.",
	db_error: "Wystapil blad serwera. Sprobuj ponownie.",
	server_error: "Wystapil blad serwera. Sprobuj ponownie.",
	ticket_access_denied: "Brak uprawnien do sprawy.",
	ticket_readonly: "Sprawa jest tylko do odczytu.",
	ticket_not_found: "Nie znaleziono zgloszenia.",
	invalid_ticketid: "Nieprawidlowy numer sprawy.",
};

const isTechnicalMessage = (message) => {
	const lower = message.toLowerCase();
	return (
		lower.includes("server error") ||
		lower.includes("missing") ||
		lower.includes("invalid") ||
		lower.includes("errorcode")
	);
};

const getUserFriendlyErrorMessage = (
	error,
	fallback = "Wystapil blad. Sprobuj ponownie.",
) => {
	const apiMessage = error?.response?.data?.message;
	const apiCode =
		error?.response?.data?.error || error?.response?.data?.errorcode;
	const status = error?.response?.status;

	if (typeof apiCode === "string" && CODE_MESSAGE_MAP[apiCode]) {
		return CODE_MESSAGE_MAP[apiCode];
	}

	if (typeof status === "number") {
		if (status === 401) {
			return "Sesja wygasla. Zaloguj sie ponownie.";
		}
		if (status === 403) {
			return "Brak uprawnien do wykonania tej operacji.";
		}
		if (status === 404) {
			return "Nie znaleziono zasobu.";
		}
		if (status >= 500) {
			return "Wystapil blad serwera. Sprobuj ponownie.";
		}
	}

	if (
		typeof apiMessage === "string" &&
		apiMessage.trim() &&
		!isTechnicalMessage(apiMessage)
	) {
		return apiMessage;
	}

	return fallback;
};

export default getUserFriendlyErrorMessage;
